export default __webpack_public_path__ + "static/media/tool_top_banner.f39bda38.png";